const keys = {
  all: ['mailgunLogs'],
  trace: (email, days) => [...keys.all, 'trace', { email, days }]
};

export default keys;
